import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Tooltip from "../tooltip/Tooltip";
import { mapAriaProps } from "../aria";
import ButtonContent from "./ButtonContent";
export const ButtonWrapperClassName = "gui-buttonWrapper";
class Button extends React.Component {
    render() {
        const props = this.props;
        const className = classNames("gui-button", props.className, {
            "gui-button--pending": props.pending,
            "gui-button--disabled": props.disabled || props.pending,
            "gui-button--cta": props.cta,
            "gui-button--small": props.small,
            "gui-button--compact": props.compact,
            "gui-button--selected": props.selected,
            "gui-button--blue": props.color === "blue",
            "gui-button--white": props.color === "white",
            "gui-button--headerBlack": props.color === "headerBlack",
            "gui-button--iconRight": props.iconPosition === "right",
            "gui-button--link": props.style === "link",
            "gui-button--inheritFontSize": props.inheritFontSize,
            "gui-button--iconOnly": props.iconOnly,
            "gui-button--link__nohovereffect": props.linkhovereffect
        });
        let button;
        if (props.pending || props.disabled) {
            button = (React.createElement("div", { className: "flex flex-direction-row" },
                React.createElement("span", { className: classNames(className, "gui-button--fakeButton") },
                    React.createElement(ButtonContent, Object.assign({}, this.props)))));
        }
        else {
            button =
                props.style === "link" ? (React.createElement("a", Object.assign({ className: classNames("udir-gui-a", className), href: "#", role: "button", onClick: evt => {
                        evt.stopPropagation();
                        evt.preventDefault();
                        if (props.onClick) {
                            props.onClick(evt.nativeEvent);
                        }
                    }, onKeyDown: props.onKeyDown ? evt => props.onKeyDown(evt) : null }, mapAriaProps(props.aria)),
                    React.createElement(ButtonContent, Object.assign({}, this.props)))) : (React.createElement("button", Object.assign({}, mapAriaProps(props.aria), { type: props.type || "button", className: className, disabled: props.disabled || props.pending, onClick: props.onClick
                        ? evt => {
                            if (props.stopPropagation) {
                                evt.stopPropagation();
                                evt.preventDefault();
                            }
                            props.onClick(evt.nativeEvent);
                        }
                        : null, onKeyDown: props.onKeyDown ? evt => props.onKeyDown(evt) : null }),
                    React.createElement(ButtonContent, Object.assign({}, this.props))));
        }
        return props.tooltip || (props.disabled && props.disabledTooltip) ? (React.createElement(Tooltip, { tooltip: (props.disabled && props.disabledTooltip) || props.tooltip, wrapperClassName: ButtonWrapperClassName, ignoreTabFocus: props.disabled || props.pending ? false : true, placement: props.tooltipPlacement }, button)) : (button);
    }
}
Button.propTypes = {
    onClick: PropTypes.func
};
Button.defaultProps = {
    type: "button",
    onClick: null
};
export default Button;
//# sourceMappingURL=Button.js.map